/* eslint react/prop-types: 0 */

import React, { useState, useEffect } from "react";
import { Loader, Button } from "semantic-ui-react";
import { useSelector } from "react-redux";
import numeral from "numeral";
import { InputFieldResponsive, InputFieldResponsive2 } from "../../component/Utils";
import { aruskas as formula } from "../../utils/financeFormula";
import Table from 'react-bootstrap/Table';
import { rkapPercentage } from "../../utils/helper";

export const Arus = (props) => {
  const user = useSelector((state) => state.main.dataUser);
  const filter = useSelector((state) => state.main);
  const reportReducer = useSelector((state) => state.reportReducer);

  const disabledInput = user.role < 4;

  const [dataInput, setDataInput] = useState({});

  const handleChange = (event) => {
    const { name, value } = event.target;
    const stringFields = ["catatan"];
    let v = value;
    if (stringFields.indexOf(name) < 0) v = parseInt(value);
    setDataInput({
      ...dataInput,
      [name]: v,
    });
  };

  const handleSubmit = () => {
    props.postData(dataInput);
  };

  useEffect(() => {
    const data = reportReducer.dataReport
      ? reportReducer.dataReport.content[0]
      : null;
    // setDataInput({ ...data });
    setDataInput({
      ...data,
      penerimaanDariPelanggan: data ? data.penerimaanDariPelanggan : null,
      penerimaanLain: data ? data.penerimaanLain : null,
      pengeluaranOperasional: data ? data.pengeluaranOperasional : null,
      pengeluaranLain: data ? data.pengeluaranLain : null,
      pengeluaranUntukPembelianAset: data
        ? data.pengeluaranUntukPembelianAset
        : null,
      pengeluaranInvestasiLain: data ? data.pengeluaranInvestasiLain : null,
      penerimaanDariPinjaman: data ? data.penerimaanDariPinjaman : null,
      penerimaanDariModalDisetor: data ? data.penerimaanDariModalDisetor : null,
      pengeluaranUntukPokokPinjaman: data
        ? data.pengeluaranUntukPokokPinjaman
        : null,
      pengeluaranPembiayaanLain: data ? data.pengeluaranPembiayaanLain : null,
      kasAwal: data ? data.kasAwal : null,
      arusAktivitasOperasi: data ? data.arusAktivitasOperasi : null,
      arusAktivitasInvestasi: data ? data.arusAktivitasInvestasi : null,
      arusAktivitasPendanaan: data ? data.arusAktivitasPendanaan : null,

      rkapKasAwal: data ? data.rkapKasAwal : null,
      rkapPenerimaanDariModalDisetor: data ? data.rkapPenerimaanDariModalDisetor : null,
      rkapPenerimaanDariPelanggan: data ? data.rkapPenerimaanDariPelanggan : null,
      rkapPenerimaanDariPinjaman: data ? data.rkapPenerimaanDariPinjaman : null,
      rkapPenerimaanLain: data ? data.rkapPenerimaanLain : null,
      rkapPengeluaranInvestasiLain: data ? data.rkapPengeluaranInvestasiLain : null,
      rkapPengeluaranLain: data ? data.rkapPengeluaranLain : null,
      rkapPengeluaranOperasional: data ? data.rkapPengeluaranOperasional : null,
      rkapPengeluaranPembiayaanLain: data ? data.rkapPengeluaranPembiayaanLain : null,
      rkapPengeluaranUntukPembelianAset: data ? data.rkapPengeluaranUntukPembelianAset : null,
      rkapPengeluaranUntukPokokPinjaman: data ? data.rkapPengeluaranUntukPokokPinjaman : null,
      rkapArusAktivitasOperasi: data ? data.rkapArusAktivitasOperasi : null,
      rkapArusAktivitasInvestasi: data ? data.rkapArusAktivitasInvestasi : null,
      rkapArusAktivitasPendanaan: data ? data.rkapArusAktivitasPendanaan : null,
      rkapKasAkhir: data ? data.rkapKasAkhir : null,
      rkapKenaikanPenurunanKas: data ? data.rkapKenaikanPenurunanKas : null,


    });
  }, [reportReducer.dataReport]);

  if (reportReducer.isLoading) {
    return (
      <div className="w-100 d-flex justify-content-center">
        <Loader active>Loading</Loader>
      </div>
    );
  }

  return (
    <>
      <h3 className="mb-4">
        Arus Kas - {filter.labelMonth} {filter.yearFilter}
      </h3>

      <Table bordereless hover>
        <thead>
          <tr>
            <td></td>
            <th width={'33%'}>Realisasi</th>
            <th width={'34%'}>RKAP</th>
            <th width={"5%"}>%</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Arus kas Dari Aktivitas Operasi</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.arusAktivitasOperasi,
                  name: "arusAktivitasOperasi",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapArusAktivitasOperasi,
                  name: "rkapArusAktivitasOperasi",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>{rkapPercentage(dataInput.arusAktivitasOperasi, dataInput.rkapArusAktivitasOperasi)}</td>
          </tr>
          <tr>
            <td>Arus kas Dari Aktivitas Investasi</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.arusAktivitasInvestasi,
                  name: "arusAktivitasInvestasi",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapArusAktivitasInvestasi,
                  name: "rkapArusAktivitasInvestasi",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>{rkapPercentage(dataInput.arusAktivitasInvestasi, dataInput.rkapArusAktivitasInvestasi)}</td>
          </tr>
          <tr>
            <td>Arus kas Dari Aktivitas Pendanaan</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.arusAktivitasPendanaan,
                  name: "arusAktivitasPendanaan",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapArusAktivitasPendanaan,
                  name: "rkapArusAktivitasPendanaan",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>{rkapPercentage(dataInput.arusAktivitasPendanaan, dataInput.rkapArusAktivitasPendanaan)}</td>
          </tr>
          <tr>
            <th>Kenaikan (Penurunan) Kas dan Setara kas</th>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.KenaikanKasSetaraKas(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.rkapKenaikanKasSetaraKas(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>{rkapPercentage(formula.KenaikanKasSetaraKas(dataInput), formula.rkapKenaikanKasSetaraKas(dataInput))}</td>

          </tr>
          <tr>
            <th>Kas dan Setara Kas Awal Periode</th>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.kasAwal,
                  name: "kasAwal",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapKasAwal,
                  name: "rkapKasAwal",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>{rkapPercentage(dataInput.kasAwal, dataInput.rkapKasAwal)}</td>
          </tr>
          {/* <tr>
            <th>Kas dan Setara Kas Awal Periode</th>
            <td>
            <span className="d-flex">
            <h5 className="mt-0 ">
              Rp. {numeral(formula.kasAwalPeriode(dataInput)).format(0, 0)}
              data mapping dari kas table neraca realisasi tahun sebelumnya
            </h5>
            </span>
            </td>
            <td>
            <span className="d-flex">
            <h5 className="mt-0 ">
              Rp. {numeral(formula.rkapKasAwalPeriode(dataInput)).format(0, 0)}
              data mapping dari kas table neraca realisasi tahun sebelumnya
            </h5>
            </span>
            </td>
          </tr> */}
          <tr>
            <th>Kas dan Setara Kas Akhir Periode</th>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.kasAkhirPeriode(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.rkapKasAkhirPeriode(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>{rkapPercentage(formula.kasAkhirPeriode(dataInput), formula.rkapKasAkhirPeriode(dataInput))}</td>
          </tr>

        </tbody>
      </Table>


      {/* <div className="mb-3">
        <InputFieldResponsive
          label="Arus kas Dari Aktivitas Operasi"
          inputType={{
            disabled: disabledInput,
            value: dataInput.arusAktivitasOperasi,
            name: "arusAktivitasOperasi",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Arus kas Dari Aktivitas Investasi"
          inputType={{
            disabled: disabledInput,
            value: dataInput.arusAktivitasInvestasi,
            name: "arusAktivitasInvestasi",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Arus kas Dari Aktivitas Pendanaan"
          inputType={{
            disabled: disabledInput,
            value: dataInput.arusAktivitasPendanaan,
            name: "arusAktivitasPendanaan",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <span className="d-flex">
          <h5>Kenaikan (Penurunan) Kas dan Setara Kas</h5>
          <h5 className="mt-0 ml-auto">
            Rp. {numeral(formula.KenaikanKasSetaraKas(dataInput)).format(0, 0)}
          </h5>
        </span>

        <InputFieldResponsive
          label="Kas dan Setara Kas Awal Periode"
          inputType={{
            disabled: disabledInput,
            value: dataInput.kasAwal,
            name: "kasAwal",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <span className="d-flex">
          <h5>Kas dan Setara Kas Akhir Periode</h5>
          <h5 className="mt-0 ml-auto">
            Rp. {numeral(formula.kasAkhirPeriode(dataInput)).format(0, 0)}
          </h5>
        </span>
      </div> */}

      {user.role >= 4 && (
        <Button
          color="blue"
          disabled={props.isLoadingButton}
          loading={props.isLoadingButton}
          onClick={handleSubmit}
        >
          Simpan
        </Button>
      )}

    </>
  );
};
